import axios from "../../axios";
import { IRepaireLibAddParams, IRepairLibDetailData, IRepairLibDetailParams, IRepaireLibListData, IRepaireLibListParams, IRepaireLibUpdateParams } from "./inspection_repair_lib.types";

/**
 * 添加
 */
export function repaireLibAdd(params: IRepaireLibAddParams) {
    return axios({
        method: 'post',
        url: '/inspection/repair/lib/add',
        data: params,
    })
}


/**
 * 删除
 */
export function repaireLibDelete(id: number) {
    return axios({
        method: 'delete',
        url: `/inspection/repair/lib/delete/${id}`,
    })
}


/**
 * 详情
 */
export function repaireLibDetail(params: IRepairLibDetailParams) {
    return axios<IRepairLibDetailData>({
        method: 'get',
        url: '/inspection/repair/lib/getDetail',
        params,
    })
}


/**
 * 分页
 */
export function repaireLibList(params: IRepaireLibListParams) {
    return axios<IRepaireLibListData>({
        method: 'get',
        url: '/inspection/repair/lib/pageList',
        params,
    })
}


/**
 * 修改
 */
export function repaireLibUpdate(params: IRepaireLibUpdateParams) {
    return axios({
        method: 'put',
        url: '/inspection/repair/lib/update',
        data: params,
    })
}
